export const PEOPLE_SEARCH_CHARACTER_MIN = 2;
export const NOTIF_STREAM_DEFAULT_IMAGE_HEIGHT = 200;
export const DEFAULT_LANGUAGE = 'en_GB';
